module.exports = __webpack_public_path__ + "static/media/dharmachakra.7c90d25d.svg";